import React from 'react'
import { Typography, Grid, Box } from '@material-ui/core'
import { Trans } from 'react-i18next'
import i18n from 'i18next'
import { useSelector } from 'react-redux'
import { useAuth } from '../context/useFetch'
import { Post } from './Post'
import { Post as Post2 } from './Post2'

const postComponents = {
  trustme: Post,
  global: Post2
}

export const LatestOffers = () => {
  const auth = useAuth()
  const offers = useSelector((state) => state.offers?.data || [])
  const siteSlug = useSelector((state) => state.site?.slug || 'global')

  // Don't show latest offers section for recruiters/companies
  if (auth.isCompany()) {
    return null
  }

  // Get the 10 most recent offers sorted by published_at (or created_at if published_at is null)
  const latestOffers = [...offers]
    .sort((a, b) => {
      const dateA = new Date(a.published_at || a.created_at)
      const dateB = new Date(b.published_at || b.created_at)
      return dateB - dateA
    })
    .slice(0, 10)

  // Don't render if there are no offers
  if (latestOffers.length === 0) {
    return null
  }

  const DynamicPostComponent = postComponents[siteSlug] || postComponents.global

  return (
    <Box mb={5} mt={8}>
      <Box mb={3}>
        <Typography variant="h2" component="h2" style={{ paddingBottom: '8px' }}>
          {i18n.t('main.latest_offers.title', { defaultValue: 'Dernières offres publiées' })}
        </Typography>
        <Typography variant="body1" color="textSecondary">
          {i18n.t('main.latest_offers.subtitle', { defaultValue: 'Découvrez les 10 dernières offres d\'emploi publiées' })}
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {latestOffers.map((offer) => (
          <Grid xs={12} sm={6} item key={offer.id}>
            <DynamicPostComponent offer={offer} />
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}
